"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceTemplateProptypes = exports.PriceProptypes = exports.PricePrefixProptypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var PriceProptypes = {
  PropTypes: {
    currency: _propTypes.default.string,
    amount: _propTypes.default.number,
    decimalType: _propTypes.default.oneOf(_constant2.ARR_DECIMAL_TYPE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    allowLocaleFormat: _propTypes.default.bool,
    locale: _propTypes.default.string,
    currencyDisplay: _propTypes.default.oneOf(Object.values(_constant2.CURR_DISPLAY)),
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    priceTemplate: _propTypes.default.oneOf(_constant2.ARR_PRICE_TEMPLATE),
    pricePrefix: _propTypes.default.oneOf(_constant2.ARR_PRICE_PREFIX),
    strikethrough: _propTypes.default.bool,
    viewport: _propTypes.default.string,
    customFontSize: _propTypes.default.string,
    customCurrencySize: _propTypes.default.string,
    noDecimalValues: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    color: _constant.DEFAULT_COLOR,
    amount: 0,
    currency: '',
    allowLocaleFormat: false,
    currencyDisplay: _constant2.CURR_DISPLAY.CODE,
    priceTemplate: _constant2.PRICE_TEMPLATE.DEFAULT,
    strikethrough: false,
    customFontSize: 'small',
    customCurrencySize: 'titleNormal',
    noDecimalValues: false
  }
};
exports.PriceProptypes = PriceProptypes;
var PriceTemplateProptypes = {
  PropTypes: {
    currencyText: _propTypes.default.string,
    amount: _propTypes.default.number,
    decimalType: _propTypes.default.oneOf(_constant2.ARR_DECIMAL_TYPE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    customFontSize: _propTypes.default.string,
    noDecimalValues: _propTypes.default.bool
  },
  DefaultProps: {
    color: _constant.DEFAULT_COLOR,
    amount: 0,
    currency: '',
    customFontSize: 'small',
    noDecimalValues: false
  }
};
exports.PriceTemplateProptypes = PriceTemplateProptypes;
var PricePrefixProptypes = {
  PropTypes: {
    prefix: _propTypes.default.string
  },
  DefaultProps: {
    prefix: null
  }
};
exports.PricePrefixProptypes = PricePrefixProptypes;